import { Bound } from "lib/@components/binding/Bound"
import { useParams, useSearchParams } from "react-router-dom"
import { useTreeItem } from "routes/schedule/lib/useTreeItem"
import { createSlot } from "lib/@components/slot/create-slot"
import { getGroupId, getScheduleId } from "library/get-unique-id-from-tree.mjs"
import { EditScheduleTailoring } from "routes/schedule/edit-schedule-tailoring"

import { getTreeId } from "library/id-helpers.mjs"
import { usePayload } from "./controller/use-payload"
import { invalidSharedRegimeAlert } from "routes/facilities/facilities"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { RegimeDraftLock } from "routes/regime/regime-draft-locking/regime-draft-lock"

export const ScheduleExtension = createSlot("ScheduleExtension")
export const ScheduleExtensionDisplay = createSlot("ScheduleExtensionDisplay")

export function ExtendedSchedule({ isEdit, isShare, scheduleId, children, draftKey, editorType, ...props }) {
    const { id: paramId } = useParams()
    const id = scheduleId ?? paramId
    const [searchParams] = useSearchParams()
    isEdit ??= !!searchParams.get("editEx")
    isShare ??= !!searchParams.get("share")
    const isCustomSchedule = id.includes("allPublished") || id.includes("allDrafts") || id.includes("allRetired")
    const item = useTreeItem(getGroupId(id))
    invalidSharedRegimeAlert(item, isShare)
    const [payload, refetch] = usePayload(getGroupId(id), getScheduleId(id), getTreeId(id))
    if (isEdit) {
        return (
            <EditScheduleTailoring
                {...props}
                payload={payload}
                id={id}
                item={item}
                draftKey={draftKey}
                editorType={editorType}
            >
                <RegimeDraftLock>{children}</RegimeDraftLock>
            </EditScheduleTailoring>
        )
    }
    return (
        <Bound
            isExtended
            currentId={id}
            currentGroup={item}
            isShare={isShare}
            payload={payload}
            refetch={refetch}
            parentItem={item}
        >
            <RegimeDraftLock>
                <If truthy={isShare || !isCustomSchedule}>
                    <ScheduleExtensionDisplay.Slot>{children}</ScheduleExtensionDisplay.Slot>
                    <Else>
                        <DemandGuard demands={["scheduleEditor"]}>
                            <ScheduleExtensionDisplay.Slot>{children}</ScheduleExtensionDisplay.Slot>
                        </DemandGuard>
                    </Else>
                </If>
            </RegimeDraftLock>
        </Bound>
    )
}
